import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import VueTheMask from 'vue-the-mask'
import BootstrapVue from 'bootstrap-vue'
import routes from './routes';
import * as VueGoogleMaps from "vue2-google-maps";
import firebase from 'firebase';
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faCar,
  faEnvelope,
  faEye,
  faEyeDropper,
  faEyeSlash,
  faHandsHelping,
  faDownload,
  faMapMarker,
  faMapMarkerAlt,
  faMoneyBill,
  faMoneyBillAlt,
  faPhone,
  faRocket,
  faHandHoldingHeart,
  faGlobe,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faFacebook,
  faFacebookF,
  faWhatsapp,
  faFacebookMessenger,
  faWhatsappSquare,
} from '@fortawesome/fontawesome-free-brands';


library.add(faCar)
library.add(faEnvelope)
library.add(faEye)
library.add(faEyeDropper)
library.add(faEyeSlash)
library.add(faFacebook)
library.add(faFacebookF)
library.add(faFacebookMessenger)
library.add(faHandHoldingHeart)
library.add(faHandsHelping)
library.add(faMapMarker)
library.add(faMapMarkerAlt)
library.add(faMoneyBill)
library.add(faMoneyBillAlt)
library.add(faPhone)
library.add(faRocket)
library.add(faWhatsapp)
library.add(faWhatsappSquare)
library.add(faDownload)
library.add(faGlobe)

Vue.use(VueTheMask)
Vue.use(BootstrapVue)
Vue.config.productionTip = false

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'


firebase.initializeApp({
  apiKey: "AIzaSyCgm3CttxUsYHoOtGyiyuQHSD8SY9yEuUw",
  authDomain: "k-9-community.firebaseapp.com",
  databaseURL: "https://k-9-community.firebaseio.com",
  projectId: "k-9-community",
  storageBucket: "k-9-community.appspot.com",
  messagingSenderId: "227320264709",
  appId: "1:227320264709:web:a2c25ed40dffe20481c46c",
  measurementId: "G-KWX2X3M4MH"
});

Vue.use(VueRouter)
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBCan97MC8P5xbKGR8WhWb9R4ifuFnsdws",
  }
});
Vue.component('font-awesome-icon', FontAwesomeIcon)


const router = new VueRouter({
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: routes
});

new Vue({
  router,
  el: '#app',
  render: h => h(App),
});
